export default __webpack_public_path__ + "static/media/video.03ea82b5.mp4";